import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

import { IUsersSearchListResponse } from './type-def';

export const getUsersIdpList = async (name: string) => {
	const resp = await apiWrapper.get<
		IUsersSearchListResponse[],
		IAPIErrorContent
	>(`${process.env.REACT_APP_USER_SERVICE_URL}/idp/users/search?query=${name}`);
	return resp;
};
